import type { TriggeringEventSpecificOptionListsType } from "./types";

export const eventSpecificOptionLists: TriggeringEventSpecificOptionListsType = {
  other: ["EVENT_PROPERTIES", "ADVANCED_EVENT_PROPERTIES"],
  sms: ["EVENT_PROPERTIES", "ADVANCED_EVENT_PROPERTIES", "SMS_PROPERTIES"],
  whatsApp: ["EVENT_PROPERTIES", "ADVANCED_EVENT_PROPERTIES", "WHATS_APP_PROPERTIES"],
};

// combine all event-specific options into a single array for use in the "anything" context
export const allEventSpecificOptions = Array.from(new Set(Object.values(eventSpecificOptionLists).flat()));
